import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFilePerformanceConfig } from '@v2/pages/tools/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsNCFilePerformanceStack = createStackNavigator();

const ToolsDetailsNCFilePerformanceNavigator = () => {
  return (
    <ToolsDetailsNCFilePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFilePerformanceConfig.map(({ Component, name }) => (
        <ToolsDetailsNCFilePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsNCFilePerformanceStack.Navigator>
  );
};

export { ToolsDetailsNCFilePerformanceNavigator };
